
const views = {
  LOGIN: 'login',
  RESULT: 'result',
}

export {
  views
}